export const SUPER_ADMIN = 'Super Admin'
export const ADMIN = 'Sysadmin'
export const INSURANCE = 'Insurance'
export const BANK = 'Bank Pusat'
export const BROKER = 'Broker'
export const BANK_CABANG = 'Bank Cabang'
export const ADMIN_REASURANSI = 'Sysadmin Reasuransi'
export const REASURANSI = 'Reasuransi'
export const USER_REINSURANCE = 'USER_REINSURANCE'